var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticStyle:{"padding-left":"80px"},domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("新升编码规范 v2.8 ")]),_c('br'),_vm._v("   本编码规范基于阿里巴巴、华为的开发手册，添加了新升团队的风格和规范，补充了一些细节。参训学员严格按照该开发规范开发， 以保证团队内风格统一，提高代码的可读性和可维护性。"),_c('br'),_c('br'),_vm._v("      “任何卷入复杂事务的人都需要团队，团队中最重要就是遵守纪律”"),_c('br'),_c('hr'),_c('br')])
}]

export { render, staticRenderFns }